/* tslint:disable:max-line-length */
export const DEFAULT_TITLE     = `
  It's your peer's turn to interview you.
  When done, click on the swap roles button on the left
`;

export const INTERVIEWER_TITLE = `
  It's your turn to be the interviewer.
  When done, click on the swap roles button on the left
`;

export const TRYOUT_TITLE = `
  Welcome to Pramp! Check out our environment,
  and sign up when you\'re ready to schedule your first live interview
`;

export const TUTORIAL_TITLE = 'Welcome to the interview practice service! Click the button below to start practicing.';
/* tslint:enable:max-line-length */
